<template>
    <h1 class="result-title">Order Details</h1>
    <div class="content">


        <div class="table-content">
            <table>
                <thead>
                    <tr class="table-header">
                        <th>Order Date</th>
                        <th>Order ID</th>
                        <th>Competition</th>
                        <th>Order Total</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>

                    <tr v-if="isLoading">
                        <td colspan="5" style="text-align: center; padding: 1.5rem;">Loading orders...</td>
                    </tr>

                    <tr class="table-row" v-for="order in orderDetails" :key="order.orderId" v-else>
                        <td>{{ order.formattedCreateDate }}</td>
                        <td>{{ order.orderId }}</td>
                        <td>{{ order.competitionName ?? '-' }}</td>
                        <td>{{ order.formattedTotalAmount }}</td>
                     




                        <td class="icon">
                            <a :href="`/orders/${order.orderId}`">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z" /></svg>
                            </a>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script lang="ts">
    import { defineComponent, ref, onMounted } from "vue";
    import { useRoute } from "vue-router";
    import Alert from "sweetalert2";
    import OrderService from "../services/order-service";
    import OrderDetails from "../models/OrderDetails";

    export default defineComponent({
        setup() {
            const route = useRoute();
            const userId = Number(route.params.userId);

            const orderDetails = ref<any[]>([]);
            const isLoading = ref(false);

            const fetchOrderDetails = async () => {
                isLoading.value = true;
                try {
                    const request: OrderDetails = {
                        orderId: "",
                        userId: userId.toString(),
                        emailAddress: ""
                    };
                    const response = await OrderService.getOrderDetails(request);

                    if (response && response.data) {
                        orderDetails.value = response.data;
                    } else {
                        Alert.fire("No Results", "No order details found for this user.", "info");
                    }
                } catch (error) {
                    console.error("Error fetching order details:", error);
                    Alert.fire("Error", "Failed to fetch order details. Please try again.", "error");
                } finally {
                    isLoading.value = false;
                }
            };

            onMounted(() => {
                fetchOrderDetails();
            });

            return {
                orderDetails,
                isLoading
            };
        }
    });
</script>




<style scoped>
    .result-title {
        position: relative;
        min-height: 89px;
        display: grid;
        grid-template-columns: 1fr 2fr;
        gap: 2rem;
        background-color: var(--clr-primary);
        padding: 1rem 1rem;
        margin-inline: 2rem;
        color: white;
        font-size: 24px;
        border-radius: 3px;
        box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
        align-items: center;
        z-index: 1;
    }



    .content {
        overflow-x: auto;
        position: relative;
        background-color: #fff;
        padding: 80px 40px 20px 40px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        border-radius: 3px;
        margin-top: -80px;
    }


    table {
        width: 100%;
        border-collapse: collapse;
        background-color: white;
    }

    td {
        padding: 0.75rem 1rem;
        text-align: left;
        border-top: 1px solid #ddd;
    }

    th {
        padding: 0.75rem 1rem;
        text-align: left;
        font-weight: bold;
    }


    .table-row:hover {
        background-color: #f1f1f1;
    }

    svg {
        height: 30px;
        display: block;
        position: relative;
        min-width: 40px;
     
        fill: var(--clr-black2);
    }
</style>